import React, { useEffect, useState } from 'react';
import AppContext from '.';
const ContextProvider = ({ children }) => {
  const [dark, setDark] = useState(false);

  const setTheme = () => {
    localStorage.setItem('isDark', !dark);
    setDark((prev) => !prev);
  };

  useEffect(() => {
    const fromStorage = localStorage.getItem('isDark');
    const initValue = fromStorage?.length
      ? fromStorage === 'true'
        ? true
        : false
      : false;
    setDark(initValue);
  }, []);

  const context = {
    setTheme,
    dark,
  };
  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};
export default ContextProvider;
